// Contexto mínimo de chart para nasdaq_quantum (copia del patrón de
// patron_ruptura_quantum/context.js): símbolo+TF actuales inyectados por la
// página del chart, usados para el gating opcional de activos y para
// namespacing de ids de señal. Nunca undefined para los consumidores.

let currentContext = { symbol: null, timeframe: null }

export function setChartContext(ctx) {
  if (!ctx || typeof ctx !== 'object') return
  currentContext = {
    symbol: typeof ctx.symbol === 'string' ? ctx.symbol : null,
    timeframe: typeof ctx.timeframe === 'string' ? ctx.timeframe : null,
  }
}

export function getChartContext() {
  return currentContext
}
